// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Fragment, useState } from "react";
import { Card } from "antd";
import styled from "styled-components";
import { ImageViewer } from "../../components/imageViewer";
import { FilePreviewItem } from "./filePreviewItem";

// FIXME: Automatically disabled during ESLint config update
// @ts-expect-error TODO(typecheck-unify): TS6133 '_CustomCard' is declared but its value is never read.
const _CustomCard = styled(Card)`
  .ant-card-body {
    padding: 5px;
  }
  img {
    width: 100%;
  }
`;

const FileContainer = styled.div`
  overflow-y: auto;
  max-height: 40vh;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'fileList' implicitly has an 'any' type.
function FilePreviewList({ fileList }) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showImageViewer, setShowImageViewer] = useState(false);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'url' implicitly has an 'any' type.
  const previewFile = (url) => () => {
    setPreviewUrl(url);
    setShowImageViewer(true);
  };

  return (
    <Fragment>
      <FileContainer>
        {/* @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'file' implicitly has an 'any' type. */}
        {fileList?.map((file, index) => (
          // FIXME: Automatically disabled during ESLint config update
          // eslint-disable-next-line react/no-array-index-key
          <FilePreviewItem file={file} key={index} previewFile={previewFile} />
        ))}
      </FileContainer>

      <ImageViewer
        visible={showImageViewer}
        images={[{ src: `${previewUrl}`, alt: "Timecard Image" }]}
        onClose={() => setShowImageViewer(false)}
      />
    </Fragment>
  );
}

export { FilePreviewList };
